import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, ReferenceLine } from "recharts";
import { TrendingUp } from "lucide-react";
import { fmtNum } from "@/lib/format";

/** 12-month demand line for the rows currently filtered (customer / model). */
export const DemandTrend = ({ months, rows, val, showMva, title }) => {
  if (!rows.length) return null;
  const data = months.map((m) => {
    const qty = rows.reduce((a, r) => a + (Number(val(r.customer_id, m.month)) || 0), 0);
    const mva = rows.reduce((a, r) => a + (Number(val(r.customer_id, m.month)) || 0) * (r.mva_per_unit || 0), 0);
    return { label: m.label, kind: m.kind, current: m.current, qty, mva: Math.round(mva) };
  });
  const key = showMva ? "mva" : "qty";
  const vals = data.map((d) => d[key]);
  const peak = Math.max(...vals), avg = vals.reduce((a, b) => a + b, 0) / vals.length;
  const firstFc = data.find((d) => d.kind === "forecast")?.label;
  return (
    <div className="pp-card p-4" data-testid="sales-demand-trend">
      <div className="flex flex-wrap items-center gap-3 mb-2">
        <div className="font-semibold flex items-center gap-1.5 text-sm"><TrendingUp size={15} className="text-blue-600" /> 12-month demand trend · {title}</div>
        <div className="ml-auto flex gap-3 text-xs text-slate-600" data-testid="sales-trend-stats"><span>Peak <b>{showMva ? `₹${fmtNum(peak)}` : fmtNum(peak)}</b></span><span>Avg/month <b>{showMva ? `₹${fmtNum(Math.round(avg))}` : fmtNum(Math.round(avg))}</b></span><span>{rows.length} row{rows.length === 1 ? "" : "s"}</span></div>
      </div>
      <div className="h-48">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={data} margin={{ top: 8, right: 16, left: 0, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
            <XAxis dataKey="label" tick={{ fontSize: 11 }} />
            <YAxis tick={{ fontSize: 11 }} tickFormatter={(v) => (v >= 1000 ? `${Math.round(v / 1000)}k` : v)} width={44} />
            <Tooltip formatter={(v) => [showMva ? `₹${fmtNum(v)}` : `${fmtNum(v)} pcs`, showMva ? "MVA" : "Demand"]} labelFormatter={(l, p) => `${l} · ${p?.[0]?.payload?.kind || ""}`} />
            {firstFc && <ReferenceLine x={firstFc} stroke="#f59e0b" strokeDasharray="4 4" label={{ value: "forecast →", fontSize: 10, fill: "#b45309", position: "insideTopRight" }} />}
            <ReferenceLine y={avg} stroke="#94a3b8" strokeDasharray="2 4" />
            <Line type="monotone" dataKey={key} stroke="#1d4ed8" strokeWidth={2.5} dot={{ r: 3, fill: "#1d4ed8" }} activeDot={{ r: 5 }} isAnimationActive={false} />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};
